class Monitoring.Models.TagsFilter

  constructor: ->
    @attributes = {}
    @attributes['name'] = 'tags'
    @attributes['values'] = []

  set: (name, value) =>
    @attributes[name] = value

  get: (name) =>
    return @attributes[name]
